import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActivationRequestModal from './ActivationRequestModal';

interface Props {
  activationRequested: boolean;
  vendorEmail: string;
  onActivationRequested: () => void;
}

export default function TrialExpiryOverlay({ activationRequested, vendorEmail, onActivationRequested }: Props) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Full-screen blur overlay — non-dismissible */}
      <div className="fixed inset-0 z-30 backdrop-blur-md bg-black/50 pointer-events-auto" />

      {/* Centered card on top */}
      <div className="fixed inset-0 flex items-center justify-center p-4 pointer-events-none" style={{ zIndex: 31 }}>
        <div className="pointer-events-auto w-full max-w-md rounded-2xl bg-[#0f1628] border border-white/10 p-8 text-white shadow-2xl text-center">
          <div className="text-4xl mb-4">⏰</div>
          <h2 className="text-2xl font-bold mb-3">{t('expiry.title')}</h2>
          <p className="text-gray-400 text-sm leading-relaxed mb-6">{t('expiry.body')}</p>

          {activationRequested ? (
            <p className="text-emerald-400 text-sm font-medium">{t('expiry.activationRequested')}</p>
          ) : (
            <button
              onClick={() => setShowModal(true)}
              className="w-full py-3 rounded-xl bg-violet-600 hover:bg-violet-500 text-white font-semibold transition-colors"
            >
              {t('expiry.requestActivation')}
            </button>
          )}

          <p className="mt-6 text-xs text-gray-600">
            {t('expiry.contactUs')}{' '}
            <a href="mailto:welcome@clareefai.com" className="text-violet-400 hover:text-violet-300 transition-colors">
              welcome@clareefai.com
            </a>
          </p>
        </div>
      </div>

      {showModal && (
        <ActivationRequestModal
          vendorEmail={vendorEmail}
          onClose={() => setShowModal(false)}
          onSuccess={onActivationRequested}
        />
      )}
    </>
  );
}
